import { useInstance } from '../../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { useEffect, useState } from 'react';
import { EditableMissionState } from '../../mission/model/EditableMissionState.ts';
import { MissionsState } from './MissionsState.ts';
import { AlertPresenter } from '../../app/AlertBinder.tsx';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';

export const useEditableMissionState = (missionId: string) => {

    const missions = useInstance(MissionsState);
    useSubscription(() => missions);

    const alert = useInstance(AlertPresenter);
    const history = useInstance(HistoryViewModel);

    const [mission, setMission] = useState<EditableMissionState>();

    useEffect(() => {
        missions.getMissionById(missionId).then(setMission)
            .catch((e: any) => {
                if (e.errorCode === 'mission.not-found') {
                    alert.showAlert({
                        header: 'Mission Not Found',
                        message: `Sorry, the mission you tried to view does not exist, or has been deleted.`
                    });
                    history.back('/missions');
                } else {
                    alert.showAndLogError(e);
                }
            });

    }, [missionId, missions, alert, history]);

    return mission;
};
